export default __webpack_public_path__ + "static/media/central.dee61342.png";